import axios from 'axios';
import {
    DELETE_TOUR_TYPE,
    GET_TOUR_TYPE,
    GET_TOUR_TYPE_SITE_MODEL_NUMBERS,
    GET_TOUR_TYPE_SITES,
    GET_TOUR_TYPES,
    POST_TOUR_TYPE,
    UPDATE_TOUR_TYPE
} from '../routes';

export default {
    async all(options = {}) {
        return await axios.get(GET_TOUR_TYPES, options);
    },
    async get(tour_type, options = {}) {
        return await axios.get(GET_TOUR_TYPE(tour_type), options);
    },
    async create(data, options = {}) {
        return await axios.post(POST_TOUR_TYPE, data, options);
    },
    async update(tour_type, options = {}) {
        return await axios.patch(UPDATE_TOUR_TYPE(tour_type), options);
    },
    async delete(tour_type, options = {}) {
        return await axios.delete(DELETE_TOUR_TYPE(tour_type), options);
    },
    async getSites(tour_type, options = {}) {
        return await axios.get(GET_TOUR_TYPE_SITES(tour_type), options);
    },
    async getSiteModelNumbers(tour_type, site, options = {}) {
        return await axios.get(GET_TOUR_TYPE_SITE_MODEL_NUMBERS(tour_type, site), options);
    },
};
